import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { pageMaxWidth } from 'utils/constants';

const PageContainer = () => (
  <Box sx={{ maxWidth: { md: pageMaxWidth }, mx: { md: 'auto' }, height: '100%', p: { xs: 2, md: 3 } }}>
    <Outlet />
  </Box>
);

export default PageContainer;
